import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import GLightbox from "glightbox";
import isologo from "../images/logo/isologo_neurocentro.png";
import neurocentroText from "../images/logo/neurocentro-text.png";
import ServiceCard from "../components/ServiceCard";
import DecorativeCircle from "../components/DecorativeCircle";
import BookUsBanner from "../components/BookUsBanner";
import PhotoGallery from "../components/PhotoGallery";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, EffectFade } from "swiper/modules";
import { agendarUrl } from "../constants";
import photoOffice from "../images/photos/office.jpg";
import photoOr from "../images/photos/or.jpg";
import photoLab from "../images/photos/lab.jpg";
import photoFisio from "../images/photos/fisio.jpg";
import photoReception from "../images/photos/DSCF3793.jpg";
import photoHospital from "../images/photos/DSCF3813.jpg";
import photoHospital3 from "../images/photos/DSCF3824.jpg";
import photoConsult from "../images/photos/DSCF3829.jpg";
import photoWaiting from "../images/photos/DSCF3832.jpg";
import photoExam from "../images/photos/DSCF3840.jpg";
import photoConsult2 from "../images/photos/DSCF3853.jpg";
import photoRehab from "../images/photos/DSCF3863.jpg";
import photoExam3 from "../images/photos/DSCF3876.jpg";

import {
  PhysiatryIcon,
  LabIcon,
  SurgeryIcon,
  RehabilitationIcon,
  HospitalIcon,
  ExternalLinkIcon,
  PlayIcon,
  DecorativeStarIcon,
  DecorativeWaveIcon,
  CardiologyIcon,
} from "../icons";

const Home = () => {
  useEffect(() => {
    // Initialize GLightbox for video
    GLightbox({
      href: "https://www.youtube.com/watch?v=XiDWtfJGHyY",
      type: "video",
      source: "youtube",
      width: 900,
      autoplayVideos: true,
    });
  }, []);

  const galleryPhotos = [
    { src: photoOffice, alt: "Fachada Neurocentro Veterinario" },
    { src: photoReception, alt: "Recepción" },
    { src: photoConsult2, alt: "Consulta veterinaria" },
    { src: photoFisio, alt: "Fisioterapia" },
    { src: photoExam3, alt: "Evaluación neurológica" },
    { src: photoHospital, alt: "Hospitalización" },
    { src: photoHospital3, alt: "Equipo hospitalario" },
    { src: photoLab, alt: "Laboratorio clínico" },
    { src: photoOr, alt: "Pabellón quirúrgico" },
    { src: photoConsult, alt: "Consulta médica" },
    { src: photoExam, alt: "Examen clínico" },
    { src: photoWaiting, alt: "Sala de espera" },
  ];

  const heroPhotos = [
    { src: photoOffice, alt: "Fachada Neurocentro Veterinario" },
    { src: photoConsult2, alt: "Consulta veterinaria" },
    { src: photoFisio, alt: "Fisioterapia" },
    { src: photoExam3, alt: "Evaluación neurológica" },
    { src: photoHospital, alt: "Hospitalización" },
    { src: photoLab, alt: "Laboratorio clínico" },
    { src: photoOr, alt: "Pabellón quirúrgico" },
    { src: photoExam, alt: "Examen clínico" },
    { src: photoRehab, alt: "Rehabilitación" },
  ];

  const services = [
    {
      icon: <CardiologyIcon />,
      title: "Consultas Especializadas",
      description:
        "Evaluación completa con médicos veterinarios especializados.",
      delay: ".2s",
    },
    {
      icon: <PhysiatryIcon />,
      title: "Diagnóstico por Imágenes",
      description:
        "Radiografías y estudios especializados para diagnóstico preciso.",
      delay: ".3s",
    },
    {
      icon: <LabIcon />,
      title: "Laboratorio Clínico",
      description: "Análisis clínicos especializados para diagnóstico.",
      delay: ".4s",
    },
    {
      icon: <SurgeryIcon />,
      title: "Cirugía",
      description: "Procedimientos quirúrgicos especializados.",
      delay: ".5s",
    },
    {
      icon: <RehabilitationIcon />,
      title: "Rehabilitación",
      description: "Programas de rehabilitación personalizados.",
      delay: ".6s",
    },
    {
      icon: <HospitalIcon />,
      title: "Atención de Urgencias",
      description: "Durante horario clínico",
      delay: ".7s",
    },
  ];

  return (
    <>
      {/* Hero Section */}
      <section id="home" className="pt-[165px]">
        <div className="container lg:max-w-[1100px] lg:px-10">
          <div className="flex flex-wrap items-center -mx-4">
            <div className="w-full px-4 lg:w-7/12">
              <div
                className="wow fadeInUp mb-12 lg:mb-0 lg:max-w-[570px]"
                data-wow-delay=".2s"
              >
                <div className="mb-6 flex items-center justify-center sm:justify-start gap-4 flex-wrap">
                  <img
                    src={isologo}
                    alt="Neurocentro Veterinario"
                    className="h-[80px] sm:h-[104px] md:h-[130px] w-auto"
                  />
                  <div className="relative h-[100px] sm:h-[130px] md:h-[160px]">
                    <img
                      src={neurocentroText}
                      alt="Neurocentro Veterinario - Viña del Mar"
                      className="h-full w-auto"
                    />
                    <img
                      src={neurocentroText}
                      alt=""
                      aria-hidden="true"
                      className="absolute inset-0 h-full w-auto invert opacity-0 dark:opacity-100"
                      style={{ clipPath: "inset(0 0 65% 0)" }}
                    />
                  </div>
                </div>
                {/* <span className="mb-5 block text-lg font-medium leading-tight text-black dark:text-white sm:text-[22px] xl:text-[22px]">
                  Cuidando la salud de tus mascotas con excelencia.
                </span> */}
                <p className="mb-10 max-w-[475px] text-base leading-relaxed text-body text-center sm:text-left">
                  Estamos ubicados en 8 Norte 1130, Viña del Mar.
                </p>

                <div className="flex flex-wrap items-center justify-center sm:justify-start">
                  <Link
                    to={agendarUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="sm:mr-6 mb-6 inline-flex h-[60px] items-center rounded-lg bg-black py-[14px] px-[30px] text-white bg-primary hover:bg-primary/90"
                  >
                    <span className="mr-[18px] border-r border-stroke/40 pr-[18px] leading-relaxed">
                      Agendar Consulta
                    </span>
                    <span>
                      <ExternalLinkIcon />
                    </span>
                  </Link>

                  {/* <a
                    href="#"
                    className="inline-flex items-center py-4 mb-6 text-black glightbox hover:text-primary dark:text-white dark:hover:text-primary"
                  >
                    <span className="mr-[22px] flex h-[60px] w-[60px] items-center justify-center rounded-full border-2 border-current">
                      <PlayIcon />
                    </span>
                    <span className="text-base font-medium">
                      <span className="block text-sm">Ver Video</span>
                      Conoce nuestras instalaciones
                    </span>
                  </a> */}
                </div>
              </div>
            </div>

            <div className="w-full px-4 lg:w-5/12">
              <div
                className="wow fadeInUp relative z-10 mx-auto w-full max-w-[430px] aspect-square lg:mr-0"
                data-wow-delay=".3s"
              >
                <div className="absolute inset-[1%] rounded-full overflow-hidden">
                  <Swiper
                    modules={[Autoplay, EffectFade]}
                    effect="fade"
                    fadeEffect={{ crossFade: true }}
                    autoplay={{ delay: 4000, disableOnInteraction: false }}
                    loop={true}
                    style={{ width: "100%", height: "100%" }}
                  >
                    {heroPhotos.map((photo, index) => (
                      <SwiperSlide key={index}>
                        <img
                          src={photo.src}
                          alt={photo.alt || ""}
                          className="w-full h-full object-cover"
                        />
                      </SwiperSlide>
                    ))}
                  </Swiper>
                </div>
                <div className="absolute top-0 left-0 right-0 w-full rounded-full max-auto -z-10 aspect-square bg-gradient-1">
                  <div className="absolute right-0 top-5">
                    <DecorativeStarIcon />
                  </div>
                  <div className="absolute left-0 bottom-10">
                    <DecorativeWaveIcon />
                  </div>
                  <div className="absolute left-[13px] bottom-6">
                    <DecorativeWaveIcon />
                  </div>
                </div>
                <div className="absolute left-[29px] bottom-2 -z-10">
                  <DecorativeWaveIcon />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="relative z-10 pt-[110px] pb-[110px]">
        <DecorativeCircle position="right-bottom" />

        <div className="container">
          <div
            className="wow fadeInUp mx-auto mb-14 max-w-[690px] text-center lg:mb-[70px]"
            data-wow-delay=".2s"
          >
            <h2 className="mb-4 text-3xl font-bold text-black dark:text-white sm:text-4xl md:text-[44px] md:leading-tight">
              Nuestros Servicios Especializados
            </h2>
            <p className="text-base text-body">
              Ofrecemos una amplia gama de servicios veterinarios con tecnología
              de última generación.
            </p>
          </div>
        </div>

        <div className="container max-w-[1390px]">
          <div className="px-5 bg-white rounded-2xl pt-14 pb-14 shadow-card dark:bg-dark dark:shadow-card-dark md:pb-1 lg:pt-20 lg:pb-5 xl:px-10">
            <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">
              {services.map((service, index) => (
                <ServiceCard
                  key={index}
                  icon={service.icon}
                  title={service.title}
                  description={service.description}
                  delay={service.delay}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <PhotoGallery
        photos={galleryPhotos}
        title="Conoce Nuestras Instalaciones"
        description="Un recorrido por nuestro centro veterinario y las áreas donde cuidamos de tu mascota."
      />

      {/* CTA Section */}
      <BookUsBanner id="contacto" />

      {/* Map Section */}
      <section className="relative z-10 pb-[110px]">
        <div className="container">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3345.5220575398944!2d-71.54699388731134!3d-33.01637397530592!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9689dd520382b681%3A0x617999ac96805742!2sNeurocentro%20Veterinario!5e0!3m2!1sen!2scl!4v1760446048614!5m2!1sen!2scl"
            width="100%"
            height="370px"
            style={{ border: "0", borderRadius: "10px" }}
            allowFullScreen=""
            loading="lazy"
            border="0"
            borderRadius="10px"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </section>
    </>
  );
};

export default Home;
